"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Carousel = Carousel;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSlick = _interopRequireDefault(require("react-slick"));

var _clsx = _interopRequireDefault(require("clsx"));

require("./slick.css");

require("./slick-theme.css");

require("./overrides.css");

var _Dropdown = _interopRequireDefault(require("../Dropdown/Dropdown"));

var _excluded = ["dropdown", "className", "value", "options"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function DefaultImageFormatter(opt) {
  return /*#__PURE__*/_react["default"].createElement("img", {
    key: opt.text || opt.value,
    alt: opt.text || opt.value,
    src: opt.url
  });
}

function DefaultFormatter(props) {
  var height = props.height,
      width = props.width,
      color = props.color;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: "".concat(width, "px"),
      height: "".concat(height, "px"),
      backgroundColor: color
    }
  }));
}

DefaultFormatter.propTypes = {
  height: _propTypes["default"].number.isRequired,
  width: _propTypes["default"].number.isRequired,
  color: _propTypes["default"].string.isRequired
};

function Carousel(props) {
  var dropdown = props.dropdown,
      className = props.className,
      value = props.value,
      options = props.options,
      rest = _objectWithoutProperties(props, _excluded);

  var optionsArray = options.map(function (opt) {
    return opt.text || opt.value;
  });

  var initialSlide = _react["default"].useRef(optionsArray.indexOf(value));

  function handleChange(e, data) {
    var val = e.target.value || data.value;
    props.onChange(null, {
      name: props.name,
      value: val
    });
  }

  function handleSlide(current, next) {
    var str = optionsArray[next];
    props.onChange(null, {
      name: props.name,
      value: str
    });
  }

  var sliderRef = _react["default"].useRef();

  _react["default"].useEffect(function () {
    var n = optionsArray.indexOf(value);
    sliderRef.current.slickGoTo(n);
  }, [optionsArray, value]);

  var settings = {
    initialSlide: initialSlide.current,
    dots: false,
    infinite: true,
    swipe: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: false,
    beforeChange: handleSlide
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "".concat(rest.name, "-carousel-container"),
    className: (0, _clsx["default"])("carousel-container ".concat(rest.name, "-carousel"), className)
  }, /*#__PURE__*/_react["default"].createElement(_reactSlick["default"], _extends({
    ref: sliderRef
  }, settings), props.options.map(function (opt) {
    var Formatter;

    if (props.formatter) {
      // custom formatter function
      Formatter = props.formatter;
    } else if (opt.url) {
      // default image formatter
      Formatter = DefaultImageFormatter;
    } else {
      Formatter = DefaultFormatter;
    }

    return /*#__PURE__*/_react["default"].createElement(Formatter, _extends({}, opt, {
      height: props.height,
      width: props.width,
      key: opt.value
    }));
  })), dropdown && /*#__PURE__*/_react["default"].createElement(_Dropdown["default"], {
    options: options,
    value: value,
    primary: true,
    onChange: handleChange
  }));
}

Carousel.defaultProps = {
  height: 140,
  width: 385
};
Carousel.propTypes = {
  className: _propTypes["default"].string,
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
    text: _propTypes["default"].string,
    key: _propTypes["default"].string,
    url: _propTypes["default"].string,
    color: _propTypes["default"].string
  })).isRequired,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
  name: _propTypes["default"].string.isRequired,
  children: _propTypes["default"].any,
  dropdown: _propTypes["default"].bool,
  formatter: _propTypes["default"].func,
  height: _propTypes["default"].number,
  width: _propTypes["default"].number,
  onChange: _propTypes["default"].func.isRequired
};
var _default = Carousel;
exports["default"] = _default;